module.exports = __webpack_public_path__ + "static/media/school_faculty_profession.37df012f.svg";